<script setup lang="ts">
import PhIcon from '@/components/PhIcon.vue'
import type { ColorKey, SizeType } from '@/types/tailwind'
import { bgColor500p25, borderColor500, textColor500 } from '@/globals/tailwind.ts'

withDefaults(
  defineProps<{
    icon: string
    color?: ColorKey
    size?: SizeType
  }>(),
  {
    color: 'blue',
    size: 'md',
  },
)

const sizeClass: Record<SizeType, string> = {
  sm: 'p-0.25 w-6 h-6 rounded-md',
  md: 'p-2 w-10 h-10 rounded-lg',
  lg: 'p-2 w-12 h-12 rounded-xl',
}

const sizeIcon: Record<SizeType, number> = {
  sm: 18,
  md: 24,
  lg: 36,
}
</script>

<template>
  <div
    :class="[
      bgColor500p25[color],
      textColor500[color],
      borderColor500[color],
      sizeClass[size as SizeType],
    ]"
    class="flex justify-center border"
  >
    <ph-icon :name="icon" class="self-center" :size="sizeIcon[size as SizeType]"></ph-icon>
  </div>
</template>

<style scoped></style>
